export var NAME = "dashboard";
export var CERTIFICATE_UPDATED = "".concat(NAME, "/CERTIFICATE_UPDATED");
export var CERTIFICATE_UPDATE_REQUESTED = "".concat(NAME, "/CERTIFICATE_UPDATE_REQUESTED");
export var DOWNLOAD_URL_REQUESTED = "".concat(NAME, "/DOWNLOAD_URL_REQUESTED");
export var DOWNLOAD_URL_REQUEST_COMPLETE = "".concat(NAME, "/DOWNLOAD_URL_REQUEST_COMPLETE");
export var DOWNLOAD_URL_REQUEST_PROGRESS = "".concat(NAME, "/DOWNLOAD_URL_REQUEST_PROGRESS");
export var EMAIL_NOTIFICATION_UPDATED = "".concat(NAME, "/EMAIL_NOTIFICATION_UPDATED");
export var EMAIL_NOTIFICATION_UPDATE_REQUESTED = "".concat(NAME, "/EMAIL_NOTIFICATION_UPDATE_REQUESTED");
export var ORDERS_LOADED = "".concat(NAME, "/ORDERS_LOADED");
export var ORDERS_REQUESTED = "".concat(NAME, "/ORDERS_REQUESTED");
export var ORDER_PAYMENT_INFORMATION_LOADED = "".concat(NAME, "/ORDER_PAYMENT_INFORMATION_LOADED");
export var ORDER_UPDATED = "".concat(NAME, "/ORDER_UPDATED");
export var SERVICES_LOADED = "".concat(NAME, "/SERVICES_LOADED");
export var NUMBER_OF_SECONDS_BETWEEN_CERTIFICATE_REQUESTS = 10;
export var NUMBER_OF_CERTIFICATE_REQUEST_RETRIES = 5;